
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/dbt-models",
      function () {
        return require("private-next-pages/extensions/dbt-models.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/dbt-models"])
      });
    }
  